/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Team_Share_Remove_ErrorInputs */

const en_team_share_remove_error = /** @type {(inputs: Team_Share_Remove_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to remove project share. ${i?.message}`)
};

const fr_team_share_remove_error = /** @type {(inputs: Team_Share_Remove_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de la suppression du partage du projet. ${i?.message}`)
};

const de_team_share_remove_error = /** @type {(inputs: Team_Share_Remove_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projektfreigabe konnte nicht entfernt werden. ${i?.message}`)
};

const it_team_share_remove_error = /** @type {(inputs: Team_Share_Remove_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile rimuovere la condivisione del progetto. ${i?.message}`)
};

const ru_team_share_remove_error = /** @type {(inputs: Team_Share_Remove_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось удалить долю проекта. ${i?.message}`)
};

const es_team_share_remove_error = /** @type {(inputs: Team_Share_Remove_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo eliminar el recurso compartido del proyecto. ${i?.message}`)
};

const zh_cn2_team_share_remove_error = /** @type {(inputs: Team_Share_Remove_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`移除项目共享失败。${i?.message}`)
};

const ja_team_share_remove_error = /** @type {(inputs: Team_Share_Remove_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プロジェクト共有を削除できませんでした。${i?.message}`)
};

const hi_team_share_remove_error = /** @type {(inputs: Team_Share_Remove_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट शेयर हटाने में विफल। ${i?.message}`)
};

const pt_pt2_team_share_remove_error = /** @type {(inputs: Team_Share_Remove_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao remover o compartilhamento do projeto. ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to remove project share. {message}" |
*
* @param {Team_Share_Remove_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_remove_error = /** @type {((inputs: Team_Share_Remove_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Remove_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_remove_error(inputs)
	if (locale === "de") return de_team_share_remove_error(inputs)
	if (locale === "it") return it_team_share_remove_error(inputs)
	if (locale === "ru") return ru_team_share_remove_error(inputs)
	if (locale === "es") return es_team_share_remove_error(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_remove_error(inputs)
	if (locale === "ja") return ja_team_share_remove_error(inputs)
	if (locale === "hi") return hi_team_share_remove_error(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_remove_error(inputs)
	return en_team_share_remove_error(inputs)
});